import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, finalize, switchMap, tap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

import { GasNetworkModel, GasStationModel, GasStationsService as ApiGasStationsService } from '@core/api';

@Injectable({
  providedIn: 'root'
})
export class GasStationsService {
  private networkDirectorySubject = new BehaviorSubject<GasNetworkModel[]>([]);
  public networkDirectory$ = this.networkDirectorySubject.asObservable();
  public networkDirectory: GasNetworkModel[] = [];

  private stationAutoCompleteSubject = new BehaviorSubject<GasStationModel[]>([]);
  public stationAutoComplete = this.stationAutoCompleteSubject.asObservable();

  private stationAutoCompleteLoadingSubject = new BehaviorSubject<boolean>(false);
  public stationAutoCompleteLoading = this.stationAutoCompleteLoadingSubject.asObservable();

  constructor(
    private apiGasStationsService: ApiGasStationsService
  ) {
    this.apiGasStationsService.gasNetworkGet().subscribe(res => {
      this.networkDirectorySubject.next(res.data);
    });

    this.networkDirectory$.subscribe(data => {
      this.networkDirectory = data;
    });
  }

  getNetworkById(id: number) :GasNetworkModel {
    const network = this.networkDirectory.find(network => network.id === id);
    return network;
  }

  getGasNetworkName(id: number) : string{
    const network = this.getNetworkById(id);

    if (network) {
      return network.name;
    }
    return '';
  }

  getStations(htmlParam: HttpParams) {
    return this.apiGasStationsService.gasStationGet(htmlParam);
  }

  getStationById(id: number) {
    return this.apiGasStationsService.gasStationIdGet(id);
  }

  registerStationAutoComplete(nativeElement) {
    fromEvent(nativeElement, 'keydown')
      .subscribe(() => {
        this.stationAutoCompleteLoadingSubject.next(true);
      });

    fromEvent(nativeElement, 'keyup')
      .pipe(
        debounceTime(350),
        distinctUntilChanged(),
        switchMap(() => {
          this.stationAutoCompleteLoadingSubject.next(true);

          return this.getStations(
            new HttpParams()
              .set('q', nativeElement.value)
          );
        })
      ).subscribe(res => {
      this.stationAutoCompleteLoadingSubject.next(false);
      this.stationAutoCompleteSubject.next(res.data);
    });
  }
}
